const inicialState = {
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  lista: [],
  listaDescarte: [],
  page: 1,
  imprimir: false,
};

export default inicialState;




// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/descarte/store/descarte.state.js